import React, { useState } from "react";
import Paper from "./Paper";

function PaperOrganizer({ papersData }) {
  const [selectedCategory, setSelectedCategory] = useState(null);

  // Get unique categories from papersData (handling both string and array formats)
  const categories = [...new Set(
    papersData.flatMap(paper =>
      Array.isArray(paper.category) ? paper.category : [paper.category]
    )
  )].sort();

  // Parse date string to Date object for sorting
  const parseDate = (dateString) => {
    return new Date(dateString);
  };

  // Filter papers based on selected category
  const getFilteredPapers = () => {
    let papers = papersData;

    if (selectedCategory) {
      // Check if paper's category includes the selected category
      papers = papers.filter(paper => {
        const paperCategories = Array.isArray(paper.category)
          ? paper.category
          : [paper.category];
        return paperCategories.includes(selectedCategory);
      });
    }

    // Sort by date in descending order (newest first)
    return papers.sort((a, b) => parseDate(b.date) - parseDate(a.date));
  };

  const filteredPapers = getFilteredPapers();

  return (
    <div className="paper-organizer">
      <div className="categories-filter">
        <button
          onClick={() => setSelectedCategory(null)}
          className={`category-btn ${selectedCategory === null ? "active" : ""}`}
        >
          All Papers
        </button>
        {categories.map((category) => (
          <button
            key={category}
            onClick={() => setSelectedCategory(category)}
            className={`category-btn ${selectedCategory === category ? "active" : ""}`}
          >
            {category}
          </button>
        ))}
      </div>

      <div className="papers-grid">
        {filteredPapers.map((paperItem) => (
          <div key={paperItem.id} className="paper-wrapper">
            <Paper paperData={paperItem} />
          </div>
        ))}
      </div>

      {filteredPapers.length === 0 && (
        <div className="no-papers">
          <p>No papers found in this category.</p>
        </div>
      )}
    </div>
  );
}

export default PaperOrganizer;
